import { CircularProgress as MuiCircularProgress } from "@mui/material";

interface CircularProgressProps {
  progress: number;
  size?: number;
}

export const CircularProgress = ({ progress, size = 80 }: CircularProgressProps) => {
  return (
    <div
      className="flex-col-el flex-center relative"
      style={{ width: size + 16, height: size + 16 }}
    >
      {/* 外側: 常に回転するリング */}
      <MuiCircularProgress
        variant="indeterminate"
        size={size + 16}
        thickness={3}
        sx={{
          color: "#2bdc98",
          position: "absolute",
          "& .MuiCircularProgress-circle": {
            strokeLinecap: "round",
          },
        }}
      />

      {/* 中央: 進捗数値 */}
      <div className="flex-col-el flex-center absolute inset-0">
        <span className="text-[20px] text-brown-80">{Math.round(progress)}%</span>
      </div>
    </div>
  );
};
